import { render } from "./ServiceFormModal.vue?vue&type=template&id=082f7d54&scoped=true"
import script from "./ServiceFormModal.vue?vue&type=script&lang=js"
export * from "./ServiceFormModal.vue?vue&type=script&lang=js"

import "./ServiceFormModal.vue?vue&type=style&index=0&id=082f7d54&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-082f7d54"]])

export default __exports__